// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"_2259675","middleSkeleton":"_463ec94","lastSkeleton":"_0bbb65d"};